// CONFIG
import {detailsNavigationIds} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';

// utils
import {createDetailsPageUrl} from './utils';
import useCarousel from '@stencil/hook-use-carousel';

// ICONS
import LeftArrowIcon from '../../../../../stories/Icons/LeftArrowIconHome';
import RightArrowIcon from '../../../../../stories/Icons/RIghtArrowIconHome';

// COMPONENTS
import SimilarHotelCard from '../SimilarHotelCard/SimilarHotelCard';

// Styles
import {
  CenteredSpaceWrap,
  FlexItem,
  LargeSectionHeader,
} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import S from './SimilarHotels.styles';
import useOmnitureLoaded from '@stencil/omniture-analytics/src/hooks/useOmnitureLoaded';
import {DetailsPageComponents} from '@stencil/omniture-analytics/src/constants/details';

//Types
import {SimilarHotelShape} from '@stencil/hotels-cg-reducer/src/details/types';

interface SimilarHotelsUIProps {
  similarHotels: SimilarHotelShape[]; // replace `any` with the actual type of `similarHotels`
  currentHotel: SimilarHotelShape; // replace `any` with the actual type of `currentHotel`
  isSoldOut?: boolean;
  heading: string;
  hotelPartner?: string;
  similarPropertiesRankingAlgo: string; // replace `string` with the actual type of `similarPropertiesRankingAlgo`
  checkinJSDate: Date; // replace `Date` with the actual type of `checkinJSDate`
  checkoutJSDate: Date; // replace `Date` with the actual type of `checkoutJSDate`
  roomString: string;
  countryCode: string;
  metaPartner: string;
  cityName: string;
}

const SimilarHotelsUI = ({
  similarHotels,
  currentHotel,
  isSoldOut = false,
  heading,
  hotelPartner = 'hotels',
  similarPropertiesRankingAlgo,
  checkinJSDate,
  checkoutJSDate,
  roomString,
  countryCode,
  metaPartner,
  cityName,
}: SimilarHotelsUIProps) => {
  const {emblaRef, emblaApi, scrollNext, scrollPrevious, leftArrowIsActive, rightArrowIsActive} =
    useCarousel();

  useOmnitureLoaded(
    `${DetailsPageComponents.SimilarProperties}_visible_dsp${
      similarPropertiesRankingAlgo ? `_rank_${similarPropertiesRankingAlgo}` : ''
    }`,
  );

  return (
    <S.Container id={detailsNavigationIds.similarHotels}>
      <CenteredSpaceWrap>
        <LargeSectionHeader>{heading}</LargeSectionHeader>

        {emblaApi && similarHotels.length > 3 && (
          <FlexItem>
            {/* Left Arrow */}
            <S.ArrowContainer onClick={scrollPrevious}>
              <S.LeftArrowWrapper>
                {/* @Todo: these should ideally be boolean instead of strings */}
                <LeftArrowIcon isactive={leftArrowIsActive ? 'true' : 'false'} />
              </S.LeftArrowWrapper>
            </S.ArrowContainer>

            {/* Right Arrow */}
            <S.ArrowContainer onClick={scrollNext}>
              <S.RightArrowWrapper>
                <RightArrowIcon isactive={rightArrowIsActive ? 'true' : 'false'} />
              </S.RightArrowWrapper>
            </S.ArrowContainer>
          </FlexItem>
        )}
      </CenteredSpaceWrap>

      <S.SimilarHotelsCardsContainer>
        {!!similarHotels.length && !isSoldOut && (
          <SimilarHotelCard
            key={currentHotel?.giId}
            hotel={currentHotel}
            id="similar-hotels-current-hotel"
            className="similar-hotel-card"
          />
        )}

        <S.EmblaCarouselContainer ref={emblaRef}>
          <S.SimilarHotelsScrollContainer>
            {!!similarHotels.length &&
              similarHotels.map((similarHotel, i) => {
                const {detailsUrlForSimilarHotel, detailsPageHotelsOnly} = createDetailsPageUrl({
                  hotel: similarHotel,
                  checkinJSDate,
                  checkoutJSDate,
                  roomString,
                  countryCode,
                  cityName: cityName,
                  partner: hotelPartner,
                  metaPartner,
                });

                return (
                  <SimilarHotelCard
                    key={similarHotel.giId}
                    hotel={similarHotel}
                    id={`similar-hotels-${i + 1}`}
                    className="similar-hotel-card"
                    index={i}
                    hotelUrl={detailsPageHotelsOnly}
                    detailsUrlForSimilarHotel={detailsUrlForSimilarHotel}
                    similarPropertiesRankingAlgo={similarPropertiesRankingAlgo}
                  />
                );
              })}
          </S.SimilarHotelsScrollContainer>
        </S.EmblaCarouselContainer>
      </S.SimilarHotelsCardsContainer>
    </S.Container>
  );
};

export default SimilarHotelsUI;
